import React from 'react';
import ButtonRadio from '.';

// TODO fix typing
export const ButtonsRadioFormWrapper = (props: any) => {
  const { input, meta, ...rest } = props;
  return (
    <ButtonRadio
      {...input}
      touched={meta.touched}
      error={meta.error}
      {...rest}
    />
  );
};

export default ButtonsRadioFormWrapper;
